import { redraw } from 'mithril'

const Ad_collections = {

    list: [
        {
            code: 'alltherage',
            title: 'All the Rage',
            subtitle: 'Typewriters, phonographs and revolvers. Products not so popular nowadays.',
            quote: 'Final Sale - King of Revolvers',
            ads: 9,
            ad_sources: [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {source: 'Collier’s Vol. 69, No. 1', link: 'https://babel.hathitrust.org/cgi/pt?id=mdp.39015019077232&seq=8'},
            ]

        },
        {
            code: 'getagirl',
            title: 'How to Get a Girl in 1940',
            subtitle: 'The strange yet similiar ads for young men of the past.',
            quote: 'I’ll Give You PROOF in Just 7 Days That You Can Have a Body Like Mine.',
            ads: 5,
            ad_sources: [
                {},
                { source: 'Strange Tales of Mystery and Terror Vol. 2, No. 2', link: "https://archive.org/details/StrangeTalesOfMysteryAndTerrorV02N02193206/page/n145/mode/2up" },
                {},
                {},
                { source: 'Planet Stories Vol. 3, No. 8', link: 'https://archive.org/details/Planet_Stories_v03n08_1947-Fall/page/n131/mode/2up' },
            ]
        },
        {
            code: 'thecure',
            title: 'Cure Your Husband’s Alcoholism',
            subtitle: 'Quack cures based on electricity, magnetisim and chemical invigoration.',
            quote: 'I honestly believe it will cure any drunkard, no matter how far down he may have fallen..',
            ads: 5,
            ad_sources: [
                {},
                {source: 'The Strand Vol. 1',link: 'https://archive.org/details/TheStrandMagazineAnIllustratedMonthly/TheStrandMagazine1891aVol.IJan-jun/page/n677/mode/2up'},
                {source: 'Strange Tales of Mystery and Terror Vol. 2, No. 2', link: 'https://archive.org/details/StrangeTalesOfMysteryAndTerrorV02N02193206/page/n1/mode/2up'},
                {},
                {},
            ]
        },
        {
            code: 'thesecret',
            title: 'The Secret to Everything',
            subtitle: 'Gurus and books to give you the power to take what you want from the world.',
            quote: 'I TALKED WITH GOD... yes I did, actually and literally.',
            ads: 4,
            ad_sources: [
                { source: 'Galaxy Magazine Vol. 5, No. 25', link: 'https://archive.org/details/galaxy_v25n06_1967-08_20240223/page/6/mode/2up' },
                { source: 'Amazing Stories Vol. 2, No. 6', link: 'https://archive.org/details/Amazing_Stories_v02n06_1927-09/page/n3/mode/2up' }
            ]
        },

    ],

}

export default Ad_collections